import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpResponse} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MockUploadInterceptor implements HttpInterceptor {

  //This is used to fake an upload cause on some screens we dont actually upload until the user tabs out of the row with all data filled in.
  //This prevents fake errors from showing in console when kendo tries to post to a nonexistent endpoint
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (req.url === '/fake-upload-endpoint' && req.method === 'POST') {
      const mockResponse = new HttpResponse({
        status: 200,
        body: { success: true, message: 'File uploaded successfully!' },
      });

      return of(mockResponse);
    }

    // Pass other requests through
    return next.handle(req);
  }
}

